import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-radio-button]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-radio-button] input[type="radio"]').forEach((input) => {
    input.addEventListener('click', (e) => {
      const isInvalid = e.target.hasAttribute('aria-invalid', 'true');
      const label = removeAccentMarkAndUppercase(
        e.target.closest('[data-au-radio-button]').querySelector('label').innerText,
      );
      const item_id = isInvalid ? `check_${label}_ko` : `check_${label}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickModulo',
        item_id,
      });
    });
  });
}

export default { init };
